export default "__VITE_ASSET__WSk2PgDX__"